import { FC } from 'react';

interface LinkAngledIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const LinkAngledIcon: FC<LinkAngledIconProps> = ({
  color = 'currentColor',
  size = '16',
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M0.583984 7.99976C0.58416 5.74485 2.41209 3.91692 4.66699 3.91675H5.00098C5.41504 3.91692 5.75098 4.25264 5.75098 4.66675C5.75098 5.08085 5.41504 5.41657 5.00098 5.41675H4.66699C3.24052 5.41692 2.08416 6.57328 2.08398 7.99976C2.08398 9.42637 3.24041 10.5836 4.66699 10.5837H6.00098C7.42755 10.5836 8.58398 9.42637 8.58398 7.99976C8.58416 7.58569 8.91988 7.24976 9.33398 7.24976C9.74809 7.24976 10.0838 7.58569 10.084 7.99976C10.084 10.2548 8.25597 12.0836 6.00098 12.0837H4.66699C2.41198 12.0836 0.583984 10.2548 0.583984 7.99976ZM13.917 7.99976C13.9168 6.57317 12.7606 5.41675 11.334 5.41675H10.001C8.57436 5.41675 7.41717 6.57317 7.41699 7.99976C7.41699 8.41397 7.08121 8.74976 6.66699 8.74976C6.25293 8.74958 5.91699 8.41386 5.91699 7.99976C5.91717 5.74474 7.74594 3.91675 10.001 3.91675H11.334C13.589 3.91675 15.4168 5.74474 15.417 7.99976C15.417 10.2549 13.5891 12.0837 11.334 12.0837H11.001C10.5869 12.0837 10.2512 11.7478 10.251 11.3337C10.251 10.9195 10.5868 10.5837 11.001 10.5837H11.334C12.7607 10.5837 13.917 9.42648 13.917 7.99976Z"
      fill={color}
    />
  </svg>
);
